<template>
  <SListItem
    data-cy="second-level-accordion-absence-types"
    :title="absenceType.meta.name"
    :description="absenceType.meta.description"
    class="second-level-accordion"
    :class="{ 'is-selected': !isSelectionMode && isAbsenceTypeSelected(absenceType) }"
    :icon="`icon-${getIcon(absenceType)}`"
    :icon-color="`${absenceType.state === 'PENDING' ? `${getIconVariant(absenceType)} border border-success` : getIconVariant(absenceType)}`"
    :aria-pressed="isPressed"
    :right-action-label="rightActionLabel"
    :right-action-label-highlighted="!!rightActionLabel"
    @click.prevent="toggleItem"
  >
    <template #right-action>
      <SCheckbox v-if="isFilterMode"
                 v-model="checked"
                 name="filter-mode"
                 :label-text="absenceType.meta.name"
      ></SCheckbox>
    </template>
  </SListItem>
</template>

<script>
import constants from 'src/config/constants.ts'
import SCheckbox from 'src/components/base/SCheckbox.vue'

export default {
  name: 'AbsenceCategoryAccordionSecondLevel',
  components: { SCheckbox },

  props: {
    absenceType: {
      type: Object,
      required: true,
    },

    absenceCategories: {
      type: Object,
      default: () => ({}),
    },

    isAbsenceTypeSelected: {
      type: Function,
      default: () => false,
    },

    isSelectionMode: {
      type: Boolean,
      default: false,
    },

    isFilterMode: {
      type: Boolean,
      default: false,
    },

    rightActionLabel: {
      type: String,
      default: '',
    },
  },

  data: () => ({
    checked: false,
  }),

  provide() {
    return {
      isUsedInSduiList: true,
    }
  },

  computed: {
    isPressed() {
      if (!this.isFilterMode) return null
      return this.checked ? 'true' : 'false'
    },
  },

  emits: ['select-absence-type'],

  methods: {
    getIcon(absenceType) {
      if (!absenceType || !Object.keys(this.absenceCategories).length || !absenceType.category) return 'sick-24'
      // determine icon by finding the group
      if (absenceType.category === constants.classbook.absences.types.keys.MISSING) return 'help'
      return this.absenceCategories[absenceType.category]?.icon
    },

    getIconVariant(absenceType) {
      if (['EXCUSED', 'PENDING'].includes(absenceType.state)) return 'success'
      if (absenceType.state === 'UNEXCUSED') return 'danger'
      return ''
    },

    toggleItem() {
      if (this.isFilterMode) this.checked = !this.checked

      this.$emit('select-absence-type', this.absenceType)
    },
  },

  created() {
    if (!this.isFilterMode) return
    this.checked = this.absenceType.selected
  },
}
</script>

<style scoped lang="scss">
.is-selected {
  position: relative;
}
.is-selected::before {
  content: '';
  width: 2px;
  height: 100%;
  background-color: $color-primary;
  display: block;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 1;
}
</style>
